/* istanbul ignore file */
export * from './FilterDetailsLoader';
